import type { FlightRoute } from 'common/packageCache';
import React from 'react';
import FontAwesomeIcon from 'comp/wraps/faIcon/FAIcon';

function renderIsActiveCell(text: string, record: FlightRoute): JSX.Element {
  if (record.isActive) {
    return <FontAwesomeIcon icon='check' color='green' />;
  }

  return <FontAwesomeIcon icon='times' color='red' />;
}

export default renderIsActiveCell;
